<style lang="less">
.ugo-form{
  .ivu-form-item{
    width:100%;
  }

  .ivu-form-item-label{
    color:var(--subtext2);
  }

  .ivu-form-item-content{
  }
}

.ugo-form-editor-root{
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fff;
  color: #333;
}
.ugo-form-editor-root.ivu-layout,
.ugo-form-editor-body.ivu-layout {
  background: #fff !important;
}
.ugo-form-editor-toolbar{
  height: 56px;
  flex-shrink: 0;
  padding: 0 !important;
  position: relative !important;
  border-bottom: 1px solid #e8e8e8;
  background: #fff;
}
.ugo-form-editor-body{
  flex: 1;
  min-height: 0;
  overflow: hidden;
  height: auto !important;
  background: #fff;
}
.ugo-form-editor-sider-left,
.ugo-form-editor-sider-left.ivu-layout-sider{
  width: 200px !important;
  max-width: 200px !important;
  min-width: 200px !important;
  flex: 0 0 200px !important;
  background: #fafbfc !important;
  border-right: 1px solid #e8e8e8 !important;
  position: relative;
  overflow: hidden;
  color: #333 !important;
  display: flex !important;
  flex-direction: column;
}
.ugo-form-editor-sider-left > .ivu-layout-sider-children{
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.ugo-form-editor-tree{
  height: 180px;
  flex: 0 0 180px;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
  background: #fafbfc;
  color: #333;
}
.ugo-form-editor-palette{
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fafbfc;
  color: #333;
}
.ugo-form-editor-palette-list{
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  display: block;
  padding-bottom: 8px;
  background: #fafbfc;
}
.ugo-form-editor-palette-drag{
  display: block;
  width: 100%;
}
.ugo-form-editor-sider-left > .ivu-layout-sider-children > .l-panel-title,
.ugo-form-editor-palette > .l-panel-title{
  flex-shrink: 0;
}
.ugo-form-editor-canvas,
.ugo-form-editor-canvas.ivu-layout-content{
  background: #f0f2f5 !important;
  overflow-y: auto !important;
  overflow-x: hidden;
  height: 100% !important;
  min-height: 0;
}
.ugo-form-editor-paper{
  width: 1000px;
  max-width: calc(100% - 24px);
  margin: 40px auto;
  background: #fff;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  min-height: 480px;
}
.ugo-form-editor-paper-inner{
  overflow: hidden;
  margin: 0;
  background: #fff !important;
  padding: 28px 24px 40px;
}
.ugo-form-editor-dropzone{
  width: 100%;
  min-height: 150px;
  background: #fff !important;
  border: 1px dashed #c9cdd4;
  padding: 5px 0;
  display: block;
}
.ugo-form-editor-sider-right,
.ugo-form-editor-sider-right.ivu-layout-sider{
  width: 240px !important;
  max-width: 240px !important;
  min-width: 240px !important;
  flex: 0 0 240px !important;
  background: #fafbfc !important;
  border-left: 1px solid #e8e8e8 !important;
  overflow-y: auto;
  overflow-x: hidden;
  color: #333 !important;
}
.ugo-form-editor-status{
  align-items: stretch;
  height: 24px;
  flex-shrink: 0;
  border-top: 1px solid #e8e8e8;
  background: #f7f8fa;
  padding: 0 !important;
  font-size: 12px;
  z-index: 100;
  color: #666;
}
.ugo-form-editor-root {
  .l-panel-title {
    background: #f2f3f5 !important;
    color: #4e5969 !important;
    border-bottom: 1px solid #e8e8e8;
  }
  .u-control-item {
    color: #333 !important;
    background: #fff !important;
    border-color: #e8e8e8 !important;
  }
  .pd-prop {
    border-bottom-color: #e8e8e8;
    .pd-label {
      color: #4e5969 !important;
      border-right-color: #e8e8e8;
      background: #f7f8fa !important;
    }
    .pd-value {
      color: #333 !important;
      background: #fff !important;
    }
  }
  .pd-embed-control,
  .pm-embed-control,
  .pd-embed-control .value-wrap,
  .pm-embed-control .value-wrap {
    background: #fff !important;
    color: #333 !important;
  }
  .form-item {
    background: #fff !important;
  }
  .form-item-selected {
    border-color: #2d8cf0 !important;
  }
  .ugo-form-root,
  .ugo-form-root--design {
    background: #fff !important;
  }
  .ivu-form-item-error-tip {
    display: none !important;
  }
  .ugo-ds-option-hint {
    margin-top: 4px;
    font-size: 12px;
    color: #cb7a00;
    line-height: 1.4;
    word-break: break-all;
  }
  .ivu-form-item-error .ivu-input,
  .ivu-form-item-error .ivu-input-number,
  .ivu-form-item-error .ivu-select-selection {
    border-color: #dcdee2 !important;
  }
  .ivu-input,
  .ivu-select-selection,
  textarea.ivu-input {
    background: #fff !important;
    color: #333 !important;
  }
}
</style>

<template>
<Layout class="ugo-form-editor-root">
  <div class="ugo-form-editor-toolbar">

    <Toolbar
      :items="tools"
      :height="60"
      :gap="3"
      @on-event="handleToolEvent"
    />
  </div>

  <Layout class="ugo-form-editor-body">
    <Sider class="ugo-form-editor-sider-left" width="200">
      <div class="l-panel-title">内容</div>
      <div class="ugo-form-editor-tree">
      <BaseTree
        ref="tree"
        :selected="selected" manu
        @event="handleTreeEvent"
        subname="fields"
        :data="computedForm"  />
    </div>
      <div class="ugo-form-editor-palette">
        <div class="l-panel-title">组件</div>
        <div class="ugo-form-editor-palette-list">
          <draggable :list="controls" :group="{ name: 'control', pull: 'clone', put: false }" :clone="handleClone" class="ugo-form-editor-palette-drag">
            <transition-group type="transition" name="flip-list" tag="div">
              <div class="u-control-item" :key="c.control" v-for="c in controls">
                <Icon :custom="`ugoicon ugi${c.icon || 'input'}`" size="18" style="margin-right:5px" /> {{c.name || c.control}}
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
    </Sider>
    <Content class="ugo-form-editor-canvas">

      <div class="ugo-form-editor-paper" :style="paperStyle">
        <template v-if="form.html">
          <a style='font-size:14px;color:#2d8cf0;position:absolute;top:-25px;' @click="view=(view=='html'?'form':'html')">切换至 {{view=='html'?'原始表单':'HTML表单'}}</a>
        </template>
         <div class="ugo-form-editor-paper-inner">
      <Form
        :label-width="form?.config?.labelWidth || 100"
        class="ugo-form ugo-form-design"
        :label-position="form.config.labelPosition || 'left'"
      >

        <template v-if="view == 'html'">

          <BaseForm :form="{layout:form.html,def:formDef}"

          v-model="formData" />
        </template>
        <template v-else>
         <draggable
          v-model="form.fields"
          @input="save"
          @end="handleDragEnd"
          group="control"
          class="ugo-form-editor-dropzone"
          :animation="500"
          filter=".drag-tip"
         >

          <!-- <BaseEmpty v-if="!form.fields || form.fields.length == 0" msg="拖拽组件到此处" /> -->

          <template v-for="(p) in form.fields">
            <div class="form-item flex-wrap flex-between" :class="selected==p?'form-item-selected':''"  :key="p.id"
            @click.stop="select(p)" style="border:1px solid #d9e2ec;margin:12px;position:relative;overflow:hidden;padding:5px;background:#fff;">
                <div class="l-mask" v-if="!isContainer(p.control)"></div>
                <div class="l-remove-btn" @click.stop="handleRemove(p)"><Icon type="md-close" /></div>
                <keep-alive>
                  <component
                    :is="p.control"
                    :required="p.required?true:false"
                    :label="p.name"
                    :id="p.id"
                    :fkey="p.key"
                    :selected="selected"
                    :fields="p.fields"
                    :config="p.config"
                    :value="p?.config?.defaultValue"
                    :editable="true"
                    :design="true"
                    @select="handleSelect"
                    @change="handleChangeFields(p,$event)"

                  />
                </keep-alive>
            </div>

          </template>

          <div v-if="form.fields && form.fields.length != 0" class="drag-tip">拖拽组件到此处</div>


         </draggable>

         </template>
      </Form>
    </div>
      </div>
    </Content>
    <Sider class="ugo-form-editor-sider-right" width="240">
      <div class="l-panel-title">组件属性</div>
      <BaseEmpty v-if="!selected || selected.name==undefined" msg="请选择组件" />
      <template v-else>
        <BaseProperty
          v-model="selected"
          :attrs="selected != form?fieldConfig:formConfig"
          :disbaled="{control:true}"
          @input="handleChange" />
          <div class="l-panel-title">组件配置</div>
        <BaseProperty
          v-if="selected"
          v-model="selected.config"
          :attrs="getAttrConfig(selected)"
          @input="handleChange"
        />
      </template>
    </Sider>
  </Layout>
  <div class="ugo-form-editor-status flex-wrap">
      <div class="flex-wrap flex-center" style="padding:0 10px;border-right:1px solid #aaa;">编辑中</div>
      <div class="flex-wrap flex-center" style="padding:0 10px;border-right:1px solid #aaa;width:calc(100% - 160px);">
        {{selecting_to?'请选择下一节点':''}}</div>

    </div>

    <Modal v-model="openFolder" title="插入现有表单" footer-hide>
      <div>
        <div class="flex-wrap">
          <Input size="small" />
        </div>
        <div  style="flex-wrap:wrap;height:400px;overflow-y:auto;margin-top:10px;padding:5px;border:1px solid var(--border);">
           <template v-for="f in forms">
            <div class="flex-wrap flex-between" :key="f.id">
              <div style="color:var(--primary);cursor:pointer;" @click="insertForm(f)">{{ f.name }}</div>
              <div>{{ moment(f.created_at).format("LL") }}</div>
            </div>
            </template>
        </div>
      </div>
    </Modal>
  </Layout>
</template>

<script>
import {cloneDeep} from 'lodash';
import draggable from 'vuedraggable';
import Toolbar from '@/components/app/toolbar';
import UgoXForm from './index.vue';


let idGlobal =1;
export default {
  props: ['value', 'public'],
  data() {
    return {
      selecting_to: null,
      view: 'form',
      selected: {},
      fields: [],
      form: {},
      forms: [],
      drag: false,
      openFolder: false,
      fieldConfig: [{
        label: '名称',
        key: 'name',
        control: 'Text',
        editable: true,
      }, {
        label: '数据名',
        key: 'key',
        control: 'Text',
        editable: true,
        option: {

          placeholder: '默认为名称',
        },
      }, {
        label: '组件',
        key: 'control',
        control: 'Text',
      }, {
        label: '必填',
        key: 'required',
        editbale: true,
        control: 'Check',
      }],
      formConfig: [{
        label: '表单名称',
        key: 'name',
        control: 'Text',
      }, {
        label: '表单类型',
        key: 'type',
        control: 'Select',
        option: {
          options: ['标准表单', '临时表单', '内嵌表单'],
        },
      }, {
        label: '表单简介',
        key: 'description',
        control: 'Text',
      }, {
        label: 'HTML表单',
        key: 'html',
        control: 'Text',
      }, {
        label: '绑定对象',
        key: 'model',
        control: 'Select',
        option: {
          valueKey: 'key',
          getters: 'session/models',
        },
      }],
    };
  },
  computed: {
    computedForm() {
      return [this.form];
    },
    nodes() {
      return [this.form];
    },
    tools() {
      if (this.public) {
        return [{}];
      }
      const staticTools = [{
        type: 'list',
        subs: [{
          key: 'open',
          name: '打开',
          icon: 'md-folder',
          type: 'icon-button',
        }]}];
      const itemTools = [
        //   {
        //   key:"extract",
        //   name:"解压",
        //   icon:"md-open",
        //   type:'icon-button'
        // }
      ];
      let tools = [...staticTools];
      if (this.selected) {
        tools.push({type: 'divider'});
        tools = tools.concat(itemTools);
      }
      return tools;
    },
    controls() {
      return this.$store.getters['forms/controls'];
    },
    formDef() {
      const o = {};
      if (this.form.fields) {
        this.form.fields.forEach((v)=>{
          if (v.key || v.name) {
            o[v.key || v.name] = {
              label: v.name,
              control: 'input',
              option: {},
            };
          }
        });
      }
      return o;
    },
    paperStyle() {
      const raw = this.form && this.form.config ? this.form.config.width : null;
      const n = Number(raw);
      const px = (n > 0 && !Number.isNaN(n)) ? n : 1000;
      return {
        width: px + 'px',
        maxWidth: 'calc(100% - 24px)',
      };
    },
  },
  mounted() {
    if (this.value) {
      this.form = cloneDeep(this.value);
    } else {
      this.form = {
        id: 'create',
        name: '新建表单',
        type: '临时表单',
        config: {},
        fields: [],
      };
    }
    this.$nextTick(()=>{
      this.selected = this.form;
      if (this.$refs.tree) {
        this.$refs.tree.select(this.form);
      }
    });
  },
  watch: {
    value: {
      handler(v, old) {
        if (v.id !== this.form.id) {
          this.form =cloneDeep(this.value);
          if (!this.selected) {
            this.selected = this.form;
          }
        }
      },
      immediate: true,
      deeply: true,
    },
  },
  methods: {
    handleEvent({type, key, value, data}) {
      const eventMap = {
        // open:this.openFormSelect,
        // search:this.getData,
        // create:this.createItem,
        // refresh:()=>{
        //   this.getStatusCounts()
        //   this.getData()

        // },

      };


      const eventHandler = eventMap[type];
      if (eventHandler) {
        eventHandler(value);
      }
    },
    traversalFeilds(fields, cb) {
      if (Array.isArray(fields) && cb) {
        fields.forEach((f)=>{
          cb(f);
          this.traversalFeilds(f.fields, cb);
        });
      }
    },
    insertForm(f) {
      let selected = this.selected;
      if (!selected) {
        selected = this.form;
      }
      this.$api.get(`forms/${f.id}`).then((res)=>{
        const {fields} = res.data.data;
        console.log(fields);
        const map = {};
        this.traversalFeilds(fields, (f)=>{
          if (!map[f.id]) {
            map[f.id] = 'field-'+f.id;
          }
        });
        this.traversalFeilds(fields, (f)=>{
          delete f.form_id;
          if (f.id && map[f.id]) {
            f.id = map[f.id];
          }
          delete f.parent_id;
        });

        this.$set(selected, 'fields', [...selected.fields, ...fields]);
        this.openFolder = false;
        this.$emit('input', cloneDeep(this.form));
      });
    },
    openFormSelect() {
      this.$api.get('forms').then((res)=>{
        this.forms = res.data.data;
        this.openFolder = true;
      });
    },
    select(item) {
      if (this.$refs.tree) {
        this.selected = this.$refs.tree.select(item);
      } else {
        this.selected = item;
      }
    },
    isContainer(control) {
      return this.$store.getters['forms/containers'].includes(control);
    },
    createID() {
      const time = Date.now();
      return time.toString(16) + idGlobal++;
    },
    handleClone({name, control}) {
      const id = this.createID();
      const obj = {
        id: 'field-'+id,
        key: 'field-'+id,
        name: `${name}${idGlobal}`,
        control,
      };
      const controlDef = this.controls.find((v)=>v.control == control);
      if (controlDef && controlDef.initModel) {
        controlDef.initModel(obj);
      }
      this.select(obj);

      return obj;
    },
    log(e) {
      // this.handleChange()

    },
    handleSelect(e) {
      const {item, ctx} = e;
      if (item) {
        this.select(item);
        this.selected_ctx = ctx;
      }
    },

    save() {
      this.$emit('input', cloneDeep(this.form));
    },
    handleChangeFields(p, fields) {
      this.$set(p, 'fields', fields);
      this.save();
    },
    handleChange() {
      if (this.timer) {
        clearTimeout();
      }
      this.timer = setTimeout(()=>{
        this.save();
      }, 300);
    },
    canUseDataSource(c){
      if (!c) return false;
      return /Input|Textarea|Select|Radio|Check/.test(c);
    },
    getAttrConfig(e) {
      const control = this.controls.find((v)=>v.control == e.control);
      if (control) {
        const defaultConfigProperties = [{
          key: 'disabled',
          label: '禁用',
          control: 'Check',
        }];
        const extraConfig = [];
        if (!this.isContainer(e.control)) {
          extraConfig.push({
            key: 'defaultValue',
            label: '默认值',
            control: 'DefaultValue',
            option: {
              control: e,
            },
          });
        }

        if(this.canUseDataSource(e.control)){
          extraConfig.push({
            label: '数据源',
            key: 'dataSource',
            control: 'DataSourceSelect'
          });
        }

        return [...defaultConfigProperties, ...(control.properties || []), ...extraConfig];
      } else if (e == this.form) {
        return [{
          label: '表单宽度',
          key: 'width',
          control: 'Number',
          option: {
            placeholder: '默认1000',
            unit: 'px',
          },
        }, {
          label: '标签宽度',
          key: 'labelWidth',
          control: 'Text',
          option: {
            number: true,
            unit: '像素',
          },
        }, {
          label: '标签位置',
          key: 'labelPosition',
          control: 'Select',
          option: {
            options: [{
              value: 'left',
              label: '靠左',
            }, {
              value: 'top',
              label: '上方',
            }, {
              value: 'right',
              label: '靠右',
            }],
          },
        }];
      } else if (e.control == 'UgoCol') {
        return [{
          label: '占比',
          help: '可填范围0-24,总占比超出24会自动换行',
          control: 'Text',
          key: 'span',
          option: {
            number: true,
          },
        }, {
          label: '对齐',
          key: 'align',
          control: 'Select',
          option: {
            options: [{
              label: '靠左',
              value: 'flex-start',
            }, {
              label: '靠右',
              value: 'flex-end',
            }, {
              label: '居中',
              value: 'center',
            }],
          },
        }];
      } else {
        return [];
      }
    },
    handleRemove(e) {
      this.form.fields.splice(this.form.fields.findIndex((v)=>v == e), 1);
      this.save();
    },
    handleTreeEvent(e) {
      if (e && e.type=='select') {
        this.selected = e.data;
      }
    },
    extract(control) {
      const vControl = this.$refs[control.key][0];
      if (vControl) {

      }
    },
    handleToolEvent(e) {
      const {key} = e;
      if (key == 'open') {
        this.openFormSelect();
      }
      if (key == 'extract') {
        this.extract(this.selected);
      }
      if (key=='clear') {
        this.form.fields = [];
        this.handleChange();
      }
    },
    handleDragEnd(e) {
      return false;
    },
  },
  components: {UgoXForm, draggable, Toolbar},
};
</script>

<style lang="less">
.u-control-item{
  width:calc(100% - 10px);
  height:35px;
  display: flex;
  align-items: center;
  border:1px solid #ddd;
  padding:0 5px;
  margin:2.5px 5px;
  overflow: hidden;
  font-size:12px;

}

.u-control-item:hover{
  background:#3399ff33;
  cursor: pointer;
  transition: 0.5s;
}
.l-mask{
  position: absolute;
  z-index:999999;
  left:0;
  top:0;
  bottom:0;
  right:0;
  opacity: 0.1;
}
.l-mask:hover{
  opacity:0.3;
  transition:opacity 0.5s;
}
.l-remove-btn{
   position: absolute;
  z-index:1000000;

  top:0;
  width:20px;
  height:20px;
  right:0;
  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.l-remove-btn:hover{
  i{
  color:var(--primary) !important;
  }
}

.form-item{
  position: relative;
  .l-mask{
    background:#2d8cf0;
  }
}

.form-item-selected{
  border-color:#2d8cf0 !important;

  .l-mask{
    background-color:#2d8cf0;
  }

}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.drag-tip{
  display: flex;
  align-items: center;justify-content: center;
  margin:5px;
  color:#aaa;
}

.l-panel-title{
height:25px;padding:4px 5px;background:#f2f3f5;font-size:10px;color:#4e5969;
border-bottom:1px solid #e8e8e8;
}
</style>
